import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M2 13h20M4 13v2.5A3.5 3.5 0 0 0 7.5 19h9a3.5 3.5 0 0 0 3.5-3.5V13M6 19l-1 2m13-2 1 2M8 10c-1-.8-1-2.2 0-3s1-2.2 0-3m4 6c-1-.8-1-2.2 0-3s1-2.2 0-3m4 6c-1-.8-1-2.2 0-3s1-2.2 0-3"
    }, null, -1)
  ])))
}
export default { render: render }